/**
 * 10.9CP — ROTEAMENTO DE TIPO DE DANO POR CLASSE. Os afixos de tipo de dano (cortante/perfurante/
 * contundente) e os nós de Poder não fazem sentido fixos: um mago causa dano ARCANO (cajado), então
 * "dano perfurante" é inútil pra ele. Aqui, cada tipo "nativo" de um afixo é redirecionado pro dano
 * que a CLASSE realmente causa: se a classe já usa aquele tipo, mantém; senão, vira o tipo primário
 * dela (mago/necro = arcano). Fonte única usada pela exibição (rótulos) e pelo combate (mods).
 */
export type PhysType = "slashing" | "piercing" | "blunt";
export type DmgType = PhysType | "arcane";

/** Tipos de dano que cada classe REALMENTE causa (pelas armas permitidas). */
const DEALT: Record<string, ReadonlySet<PhysType>> = {
  warrior: new Set<PhysType>(["slashing", "blunt"]), // espada/machado (cortante) + clava (contundente)
  archer: new Set<PhysType>(["piercing"]),           // arco
  mage: new Set<PhysType>([]),                        // cajado → arcano (nenhum físico)
  necromancer: new Set<PhysType>([]),                // cajado → arcano
};
/** Pra onde vai um afixo cujo tipo a classe NÃO usa. */
const PRIMARY: Record<string, DmgType> = {
  warrior: "slashing",
  archer: "piercing",
  mage: "arcane",
  necromancer: "arcane",
};

/** Redireciona um tipo nativo pro dano que a classe realmente causa. Classe desconhecida: mantém. */
export function routeDamageType(native: PhysType, classId: string | null | undefined): DmgType {
  if (!classId || !(classId in DEALT)) return native;
  return DEALT[classId].has(native) ? native : (PRIMARY[classId] ?? native);
}

/** Chave de atributo de um afixo físico → seu tipo nativo. */
export function attrToType(key: string): PhysType | null {
  return key === "dmgSlash" ? "slashing" : key === "dmgPierce" ? "piercing" : key === "dmgBlunt" ? "blunt" : null;
}

/** Tipo de dano → chave i18n do rótulo de atributo (equipment.attr.*). */
export function typeToAttrLabel(t: DmgType): string {
  return t === "slashing" ? "equipment.attr.dmgSlash"
    : t === "piercing" ? "equipment.attr.dmgPierce"
    : t === "blunt" ? "equipment.attr.dmgBlunt"
    : "equipment.attr.dmgArcane";
}
